import type { IconSvgObject } from './types';

const LigatureIcon: IconSvgObject = [
  ["path", { d: "M15 5.35418C14.2671 4.52375 13.1947 4 12 4C9.79086 4 8 5.79086 8 8V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 20H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 12H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 20V13.4878C16 12.6127 16 12.1752 15.7236 12.0367C15.4472 11.8981 15.0981 12.1606 14.4 12.6856L14 12.9864", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M14 20H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default LigatureIcon;
